import { render, staticRenderFns } from "./ResetSuggestedOrdersModal.vue?vue&type=template&id=30873994&scoped=true"
import script from "./ResetSuggestedOrdersModal.vue?vue&type=script&lang=js"
export * from "./ResetSuggestedOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./ResetSuggestedOrdersModal.vue?vue&type=style&index=0&id=30873994&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30873994",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2966086841/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30873994')) {
      api.createRecord('30873994', component.options)
    } else {
      api.reload('30873994', component.options)
    }
    module.hot.accept("./ResetSuggestedOrdersModal.vue?vue&type=template&id=30873994&scoped=true", function () {
      api.rerender('30873994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResetSuggestedOrdersModal.vue"
export default component.exports